// extracted by mini-css-extract-plugin
var _1 = "RightPanel-module__animateUploadProgressBarWidth--UY_RC";
var _2 = "RightPanel-module__animatedBackground--lNnI1";
var _3 = "1px";
var _4 = "RightPanel-module__closeButton--Na4gT";
var _5 = "RightPanel-module__headerControls--_dRRD";
var _6 = "RightPanel-module__iconButton--DGYLS";
var _7 = "RightPanel-module__iconButtons--Lbwt5";
var _8 = "RightPanel-module__isActive--fpJQX";
var _9 = "RightPanel-module__isOpen--LvmyA";
var _a = "RightPanel-module__isPinned--xVi2x";
var _b = "RightPanel-module__isResizing--WsKtD";
var _c = "150";
var _d = "RightPanel-module__resizeHandle--zchA_";
var _e = "544px";
var _f = "RightPanel-module__rightPanelHeader--VgRjA";
var _10 = "RightPanel-module__rightPanelInner--cIP0Y";
var _11 = "RightPanel-module__rightPanelInnerContainer--bzUH4";
var _12 = "RightPanel-module__rightPanelInnerContent--WifhE";
var _13 = "321px";
var _14 = "RightPanel-module__rightPanelNewHeader--ubwZe";
var _15 = "RightPanel-module__rightPanelRoot--J5FUx";
var _16 = "RightPanel-module__rightPanelRootContainer--CGj4q";
var _17 = "RightPanel-module__rightPanelRootContent--CbgsB";
var _18 = "337px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "borderWidth", _4 as "closeButton", _5 as "headerControls", _6 as "iconButton", _7 as "iconButtons", _8 as "isActive", _9 as "isOpen", _a as "isPinned", _b as "isResizing", _c as "layoutAnimationDurationMs", _d as "resizeHandle", _e as "resizeMaxWidth", _f as "rightPanelHeader", _10 as "rightPanelInner", _11 as "rightPanelInnerContainer", _12 as "rightPanelInnerContent", _13 as "rightPanelMobileWidth", _14 as "rightPanelNewHeader", _15 as "rightPanelRoot", _16 as "rightPanelRootContainer", _17 as "rightPanelRootContent", _18 as "rightPanelWidth" }
